<template>
  <a-drawer
    width="80%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-tabs :activeKey="tabs">
      <a-tab-pane
        key="1"
        tab="管线信息"
        v-if="type == 1"
      >
        <pipelinePage
          :customUserId="customUserId"
          v-if="tabs == 1"
        ></pipelinePage>
      </a-tab-pane>
      <a-tab-pane
        key="2"
        tab="设备信息"
        force-render
      >
        <devicePage
          :customUserId="customUserId"
          v-if="tabs == 2"
          :deviceCategorizeId="deviceCategorizeId"
          :deviceTypeId="deviceTypeId"
          :pipelineId="pipelineId"
          :interferenceTypeId="interferenceTypeId"
        ></devicePage>
      </a-tab-pane>
    </a-tabs>
  </a-drawer>
</template>

<script>
import { getUser, addUser, updateUser } from '@/api/system/user'
import pipelinePage from './saifuneng/pipeline/index.vue'
import devicePage from './saifuneng/device/index.vue'
export default {
  name: 'CreateForm',
  props: {

  },
  components: {
    pipelinePage,
    devicePage
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      customUserId: '',
      // 1增加,2修改
      formType: 1,
      tabs: 1,
      open: false,
      pipelineId: '',
      type: '',
      deviceCategorizeId: '',
      deviceTypeId: '',
      interferenceTypeId: ''
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.tabs = ''
    },
    /** 新增按钮操作 */
    handleAdd (id, e, type) {
      this.type = type
      this.formType = 1
      this.tabs = e + ''
      console.log(this.tabs, '大大大大大');
      if (type == 1) {
        this.customUserId = id
      } else if (type == 2) {
        this.pipelineId = id
      } else if (type == 3) {
        this.deviceTypeId = id
      } else if (type == 4) {
        this.interferenceTypeId = id
      }else if (type == 5) {
        this.deviceCategorizeId = id
      }
      this.$forceUpdate()
      this.open = true
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUser(id).then(response => {
        this.form = response.data.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUser(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUser(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less">
.ant-upload-preview {
  position: relative;
  width: 100px;
  height: 100px;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .mask {
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    overflow: hidden;
    object-fit: contain;
  }
}
</style>
